export const barPreviewTitles = new Set([
  'Variação acumulada do ano (comparação anual)',
  'Variação mensal (ano contra ano)',
  'Tendência do mês atual (comparação anual)',
  'Variação mês a mês',
  'Tendência do mês atual (comparação sequencial)',
])

const monthYearShortLabelTitles = new Set([
  'variacao mensal (ano contra ano)',
  'tendencia do mes atual (comparacao sequencial)',
  'tendencia do mes atual (comparacao anual)',
  'variacao mes a mes',
])

export const normalizeVisualizationTitle = (title?: string | null) =>
  (title ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const usesMonthYearShortLabel = (title?: string | null) =>
  monthYearShortLabelTitles.has(normalizeVisualizationTitle(title))
